import { useState, useEffect } from 'react';
import { axiosRecentHiringActivity } from 'modules/hiring/stateManagement/api';
import { IHiringActivity } from 'modules/hiring/models/recentHiringActivity.model';

export const useRecentHiringActivity = () => {
  const [recentHiringActivity, setRecentHiringActivity] =
    useState<IHiringActivity[]>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axiosRecentHiringActivity();
        setRecentHiringActivity(response.candidateActivityHistory);
        setError(null);
      } catch (apiError: any) {
        setError(apiError.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { recentHiringActivity, loading, error };
};
